var _rect, _g, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntervirtualclassroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#F0F3F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_827_40342)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    y: -3695,
    width: 1440,
    height: 8103,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -108,
    y: -3695,
    width: 1440,
    height: 8306,
    fill: "#F5F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -36,
    y: -464,
    width: 1295,
    height: 1322,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0912 18.666C19.7587 18.666 18.667 19.7577 18.667 21.0903V24.7266H19.8791H44.1215V36.8478C44.1215 37.5298 43.5914 38.06 42.9094 38.06H33.809C33.8147 37.9563 33.8185 37.8524 33.8185 37.7486C33.8185 35.5392 32.5523 33.5578 30.6249 32.6007C31.105 32.0238 31.3943 31.2832 31.3943 30.4783C31.3943 28.6475 29.8961 27.1509 28.0645 27.1509C26.2328 27.1509 24.7335 28.6475 24.7335 30.4783C24.7335 31.2832 25.0237 32.0237 25.5041 32.6007C23.5767 33.558 22.3093 35.5392 22.3093 37.7486C22.3093 37.8525 22.313 37.9563 22.3187 38.06H21.0912C20.4092 38.06 19.8791 37.5298 19.8791 36.8478V25.9387H18.667V36.8478C18.667 38.1804 19.7587 39.2721 21.0912 39.2721H42.9094C44.242 39.2721 45.3337 38.1804 45.3337 36.8478V21.0903C45.3337 19.7577 44.242 18.666 42.9094 18.666H21.0912ZM21.0912 19.8781H42.9094C43.5914 19.8781 44.1215 20.4083 44.1215 21.0903V23.5145H19.8791V21.0903C19.8791 20.4083 20.4092 19.8781 21.0912 19.8781ZM28.0645 28.363C29.2417 28.363 30.1821 29.3032 30.1821 30.4783C30.1821 31.6534 29.2417 32.5936 28.0645 32.5936C26.8872 32.5936 25.9456 31.6534 25.9456 30.4783C25.9456 29.3032 26.8872 28.363 28.0645 28.363ZM26.5884 33.4589C27.034 33.6807 27.5352 33.8057 28.0645 33.8057C28.5938 33.8057 29.0951 33.6807 29.5406 33.4589C31.3684 34.0852 32.6064 35.7999 32.6064 37.7486C32.6064 37.8526 32.6018 37.9563 32.5945 38.06H23.5332C23.526 37.9563 23.5214 37.8527 23.5214 37.7486C23.5214 35.7995 24.7604 34.0849 26.5884 33.4589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7276 40.4844C23.6052 40.4844 22.6556 41.2613 22.3838 42.3026H18.667V43.5147H22.3838C22.6556 44.5559 23.6052 45.3329 24.7276 45.3329C25.8503 45.3329 26.8023 44.5564 27.0737 43.5147H45.3337V42.3026H27.0737C26.8023 41.2608 25.8503 40.4844 24.7276 40.4844ZM24.7276 41.6965C25.4042 41.6965 25.9397 42.232 25.9397 42.9086C25.9397 43.5852 25.4042 44.1207 24.7276 44.1207C24.051 44.1207 23.5155 43.5852 23.5155 42.9086C23.5155 42.232 24.051 41.6965 24.7276 41.6965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5375 27.2268C36.4452 27.1755 36.3411 27.1491 36.2355 27.1504C36.1298 27.1517 36.0264 27.1806 35.9353 27.2342C35.8443 27.2878 35.7689 27.3642 35.7165 27.456C35.6641 27.5477 35.6366 27.6515 35.6367 27.7572V33.8178C35.6366 33.9234 35.6641 34.0272 35.7165 34.119C35.7689 34.2107 35.8443 34.2871 35.9353 34.3407C36.0264 34.3943 36.1298 34.4232 36.2355 34.4245C36.3411 34.4258 36.4452 34.3994 36.5375 34.3481L41.9921 31.3178C42.0868 31.2653 42.1657 31.1885 42.2207 31.0952C42.2757 31.002 42.3047 30.8957 42.3047 30.7875C42.3047 30.6792 42.2757 30.5729 42.2207 30.4797C42.1657 30.3864 42.0868 30.3096 41.9921 30.2572L36.5375 27.2268ZM36.8488 28.7882L40.4485 30.7875L36.8488 32.7879V28.7882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6973 21.0898V22.302H42.9094V21.0898H41.6973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2729 21.0898V22.302H40.4851V21.0898H39.2729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8486 21.0898V22.302H38.0608V21.0898H36.8486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4248 21.0898V22.302H35.6369V21.0898H34.4248Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -107.5,
    y: -3694.5,
    width: 1439,
    height: 8102,
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -4487,
    y: -12826,
    width: 53660,
    height: 41487,
    stroke: "black",
    strokeWidth: 50
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_827_40342"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    y: -3695,
    width: 1440,
    height: 8103,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntervirtualclassroom);
export default __webpack_public_path__ + "static/media/enter virtual classroom.f9022b60d481722537b2bf89ec808d31.svg";
export { ForwardRef as ReactComponent };